// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__BAI2-","appList":"NavBar_appList__CJVZw","userPanel":"NavBar_userPanel__c+y6S"};